import {
  Alert,
  AlertIcon,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  AlertTitle,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { REQUEST_DELETE_MASTER_COUPON } from "../../store/coupon/couponActionType";
import { useCouponsMaster } from "../../store/coupon/reducer";
import { useLinksMaster } from "../../store/linkMaster/reducer";
interface Props {
  coupon: Record<string, any>;
  isOpen: any;
  onClose: any;
}
const CouponDelete: React.FC<Props> = ({ coupon, isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { masterCoupons: coupons, busy, message } = useCouponsMaster();
  const { _id } = coupon;
  useEffect(() => {
    const findLink = coupons.find(
      (val: Record<string, any>) => val._id === _id
    );
    if (!findLink) {
      onClose();
    }
  }, [_id, coupons, onClose]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Coupon</ModalHeader>
        <ModalCloseButton disabled={busy} />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            Are you sure to delete? {coupon.couponName}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose} disabled={busy}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            disabled={busy}
            onClick={() => {
              dispatch({
                type: REQUEST_DELETE_MASTER_COUPON,
                payload: { _id: coupon._id },
              });
            }}
          >
            Submit
          </Button>
        </ModalFooter>
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon />
              <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default CouponDelete;
